import { render, staticRenderFns } from "./checkpage.vue?vue&type=template&id=28e4e2bc&scoped=true&"
import script from "./checkpage.vue?vue&type=script&lang=js&"
export * from "./checkpage.vue?vue&type=script&lang=js&"
import style0 from "./checkpage.vue?vue&type=style&index=0&id=28e4e2bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4e2bc",
  null
  
)

export default component.exports